module.exports = __webpack_public_path__ + "media/images/flags/hk-f1543fd885ab4d3db3d942f98a30cb4c.svg";